<template>
  <div>
    <div class="body">
      <div class="td">
        <img
          src="../../assets/frame-img/3d.png"
          @click="goto(list.model_id)"
          v-if="list.model_id !=null"
        >
      </div>
      <van-nav-bar :title="title" left-arrow @click-left="onClickLeft" class="topNav"/>
      <div class="content animated fadeInRight">
        <van-swipe :autoplay="3000" @change="onChange" class="custom">
          <van-swipe-item v-for="(item,index) in list.imgList" :key="index">
            <img src="../../assets/frame-img/logo.png" class="logo">
            <img :src="item | thumbnail(750,750)" @click="bigImg()">
          </van-swipe-item>
          <div class="custom-indicator" slot="indicator">{{ current + 1 }}/{{list.imgList.length}}</div>
        </van-swipe>
        <div class="goodsMsg">
          <div class="mesBody">
            <div class="msgLeft">
              <p class="msgName">{{list.name}}</p>
              <p class="msgPrice">￥{{list.price}}</p>
            </div>
            <!-- <div class="msgRight">
              <i class="iconfont icon-fenxiang"/>
              <p>分享</p>
            </div>-->
          </div>
          <div class="msgFoot">销量：{{list.sales}}</div>
        </div>
        <div class="goodsSku" v-if="list.hasSpec&&list.sku.length>1" @click="openAction()">
          <p>
            选择:
            <span>{{selskuname}}</span>
          </p>
          <van-icon class="selIcon" name="arrow"/>
        </div>
        <p class="contentTitle">商品描述</p>
        <div class="goodsContent" v-html="list.content"/>
      </div>
    </div>
    <div class="footer">
      <div class="footer_left">
        <!-- <div class="leftBtn">
          <i class="iconfont icon-kefu"/>
        </div>-->
        <div class="leftBtn" @click="$router.push('/pages/flow/index')">
          <div style="position: relative">
            <i class="iconfont icon-gouwuche"/>
            <div
              class="btnInfo"
              :class="certNum<=0? 'noInfo':''"
              @click="$router.push('/pages/flow/index')"
            >{{certNum}}</div>
          </div>
        </div>
      </div>
      <div class="footer_right">
        <button class="addgwc" @click="openAction()">加入购物车</button>
        <button class="bynow" @click="openAction()">立即购买</button>
      </div>
    </div>
    <div class="footerPo1pup">
      <van-actionsheet v-model="showSheet">
        <DetailSheet :list="list" :selskuid="selskuid" @changeActive="changeActive" @AddCart="AddCart" @ByNow="ByNow"/>
      </van-actionsheet>
    </div>
  </div>
</template>

<script>
import { GetGoods, AddCart } from "../../apis/https.js";
import {
  Swipe,
  SwipeItem,
  NavBar,
  Icon,
  Actionsheet,
  ImagePreview
} from "vant";
import { getLocalStorage } from "../../utils/storage.js";
import { checkToken, checkAgree } from "../../utils/token.js";
import DetailSheet from "@/components/DetailSheet.vue";
import Vue from "vue";
Vue.use(Swipe)
  .use(SwipeItem)
  .use(NavBar)
  .use(Icon)
  .use(Actionsheet);
export default {
  components: {
    DetailSheet
  },
  props: {},
  data() {
    return {
      title: "商品详情",
      id: "",
      current: 0,
      loading: false,
      list: {
        name: "",
        price: "",
        content: "",
        imgList: [],
        sku: [], // {group_id,group_name,spec_items{goods_no,goods_price,goods_weight,goods_weight_g,image_id,image_path,item_id,line_price,spec_value,stock_num}
        sales: "",
        hasSpec: false,
        specItem: [],
        model_id: null,

      },
      certNum: 0,
      selSkuIndex: 0,
      showSheet: false
    };
  },
  computed: {
    // spec() {
    //   return this.list.spec;
    // },
    selskuid() {
      if (this.list.hasSpec) {
        let skuid = "";
        for (let i in this.list.sku) {
          skuid =
            skuid +
            "_" +
            this.list.sku[i].item[this.list.sku[i].active].item_id;
        }
        skuid = skuid.substring(1,skuid.length)
        return skuid;
      } else {
        return 0;
      }
    },
    selskuname() {
      let result = "";
      for (let i in this.list.sku) {
        result =
          result +
          " " +
          this.list.sku[i].item[this.list.sku[i].active].spec_value;
      }
      return result;
    }
  },
  watch: {

  },
  created() {},
  mounted() {},
  activated() {
    if (this.id != this.$route.query.id) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.id = this.$route.query.id || this.$route.query.goods_id;
      this.GetGood(this.id, getLocalStorage("login_token"));
    }
  },
  destroyed() {},
  methods: {
    GetGood(id, token) {
      GetGoods(id, token)
        .then(res => {
          let data = res.data.detail;
          let imgList = [];
          for (let i in data.image) {
            imgList.push(data.image[i].file_path);
          }
          this.list.name = data.goods_name;
          this.list.price = data.sku[0].goods_price;
          this.list.content = data.content;
          this.list.imgList = imgList;
          this.list.sales = data.goods_sales;
          this.certNum = res.data.cart_total_num;
          this.list.model_id = data.model_id || null;
          if (res.data.specData == null) {
            this.list.sku = data.sku;
            this.list.hasSpec = false;
          } else {
            this.list.hasSpec = true;
            this.list.specItem = res.data.specData.spec_list;
            this.list.sku = this.GetSkuObject(res.data.specData);
          }
          this.$toast.clear();
        })
        .catch(e => {});
    },
    onChange(index) {
      this.current = index;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    GetSkuObject(data) {
      let spec = data.spec_attr;
      let result = [];
      for (let i in spec) {
        result.push({
          active: 0,
          group_name:spec[i].group_name,
          item: []
        });
        for (let j in spec[i].spec_items) {
          result[i].item.push(spec[i].spec_items[j]);
        }
      }
      return result;
    },
    openAction() {
      this.showSheet = !this.showSheet;
    },
    changeActive(data) {
      this.list.sku[data.specGroup].active=data.specItem;
    },
    AddCart(value) {
      // goods_id,goods_num,goods_sku_id,token
      let skuid = 0;
      if (this.list.hasSpec) {
        skuid = this.selskuid;
      }
      AddCart(this.id, value.value, skuid, getLocalStorage("login_token"))
        .then(res => {
          this.certNum = res.data.cart_total_num;
          this.$toast.success("加入购物车成功");
          this.showSheet = false;
        })
        .catch(e => {});
    },
    ByNow(value) {
      let skuid = 0;
      if (this.list.hasSpec) {
        skuid = this.selskuid;
      }
      this.$store.commit("ORDER", {
        goods_sku_id: skuid,
        goods_num: value.value,
        goods_id: this.id
      });
      this.$router.push({
        name: "cartsub"
      });
    },
    goto(mid) {
      location.href = "https://m.p.gemtec.ltd/#/model-view/" + mid;
    },
    bigImg() {
      ImagePreview(this.list.imgList);
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.logo {
  position: absolute;
  top: 30px;
  right: 60px;
  width: 70px !important;
  height: 35px !important;
}
.body {
  background: #f4f8fb;
  min-height: 100vh;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-bottom: 46px;
    margin-top: 46px;
    .custom {
      height: 375px;
      width: 375px;
      border-bottom: 1px solid #eee;
      .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 2px 5px;
        color: @white;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.1);
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .goodsMsg {
      padding: 10px;
      background: @white;
      margin-bottom: 10px;
      .mesBody {
        display: flex;
        .msgLeft {
          flex: 1 1 auto;
          .msgName {
            color: #333;
            font-size: 15px;
            display: -webkit-box;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          .msgPrice {
            margin-top: 5px;
            font-size: 16px;
            font-weight: 700;
            color: @text;
          }
        }
        .msgRight {
          width: 35px;
          text-align: center;
          i {
            font-size: 30px;
          }
          p {
            font-size: 12px;
          }
        }
      }
      .msgFoot {
        font-size: 14px;
        color: #888;
        margin-top: 5px;
      }
    }
    .goodsSku {
      display: flex;
      background: @white;
      margin-bottom: 10px;
      padding: 0px 10px;
      flex-wrap: nowrap;
      p {
        flex: 1 1 auto;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        color: #999;
        span {
          font-size: 14px;
          color: #333;
        }
      }
      .selIcon {
        display: block;
        height: 40px;
        width: 40px;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
      }
    }
  }
}
.footer {
  width: 100%;
  height: 46px;
  position: fixed;
  bottom: 0px;
  background: @white;
  overflow: hidden;
  display: flex;
  .footer_left {
    display: flex;
    height: 46px;
    background: @gray;
    .leftBtn {
      display: block;
      height: 46px;
      padding: 10px;
      border-right: 1px solid #eee;
      i {
        width: 26px;
        height: 26px;
        font-size: 28px;
        line-height: 26px;
        color: #7a7e83;
        display: block;
      }
      .btnInfo {
        position: absolute;
        top: -8px;
        right: 0;
        box-sizing: border-box;
        min-width: 16px;
        padding: 0 3px;
        color: @white;
        font-weight: 500;
        font-size: 12px;
        font-family: PingFang SC, Helvetica Neue, Arial, sans-serif;
        line-height: 14px;
        text-align: center;
        background-color: @btn;
        border: 1px solid @white;
        border-radius: 16px;
        -webkit-transform: translateX(50%);
        transform: translateX(50%);
        -webkit-transform-origin: 100%;
        transform-origin: 100%;
      }
      .noInfo {
        display: none;
      }
    }
  }
  .footer_right {
    flex: 1 1 auto;
    button {
      width: 50%;
      border: 0px;
      height: 46px;
      font-size: 14px;
      color: @white;
      vertical-align: top;
    }
    .addgwc {
      // background: linear-gradient(to right, #fac905 0, #ff9500 100%);
      color: @darkP;
      background: @gray;
    }
    .bynow {
      // background: linear-gradient(to right, #fa1e8c 0, #fc1e56 100%);
      color: @white;
      background: @btn;
    }
  }
}
.td {
  position: fixed;
  top: 60px;
  right: 10px;
  z-index: 2;
  width: 50px;
  height: 50px;
  img {
    width: 100%;
    height: 100%;
  }
}

.contentTitle {
  font-size: 12px;
  border-bottom: 1px solid #f4f4f4;
  background: #fff;
  padding: 10px 10px;
}

.footerPo1pup .van-popup {
  overflow-y: visible !important;
}
</style>
<style>
.goodsContent img {
  width: 100%;
}
.footerPo1pup /deep/ .van-popup {
  overflow-y: visible !important;
}

@media (device-height: 812px) and (device-width: 375px) {
  .footer {
    height: 2.133333rem !important;
    padding-bottom: 0.8rem !important;
    background: #fff;
  }
}
.goodsContent img {
  pointer-events: none;
  -webkit-user-select: none; /*禁用手机浏览器的用户选择功能 */
  -moz-user-select: none;
}
</style>